import React, { useState } from "react";
import "./InfoFieldLocations.scss";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import { getService } from "../../../../../services/axios/services";

const InfoFieldLocations = ({ items, label }) => {
  const [open, setOpen] = useState(false);
  const [hierarchy, setHierarchy] = useState([]);

  if (!items || !items.length) return null;

  const showOrdinal = items.length > 1;

  const handleOpenDialog = async (location) => {
    try {
      const res = await getService({
        endpoint: `location/${location.id}/hierarchy`,
      });
      setHierarchy(res.data || []);
      setOpen(true);
    } catch (error) {
      console.error("Erro ao buscar hierarquia:", error);
    }
  };

  return (
    <div className="infoField">
      <span className="infoName">{label}</span>
      <div className="infoDataList">
        {items.map((item, index) => {
          const location = item.location || {};
          return (
            <div className="infoData" key={index}>
              {showOrdinal && (
                <span className="locationOrdinal">{index + 1}ª</span>
              )}{" "}
              {location.type && (
                <span className="locationType">
                  {location.type}
                  {location.isFictional && (
                    <>
                      {" "}
                      <span className="fictional">Fictício</span>
                    </>
                  )}
                  :
                </span>
              )}{" "}
              {location.name || location.value}
              <IconButton
                size="small"
                className="locationIcon"
                onClick={() => handleOpenDialog(location)}
              >
                <MoreHorizIcon fontSize="small" />
              </IconButton>
            </div>
          );
        })}
      </div>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs">
        <DialogContent>
          {hierarchy.length > 0 ? (
            hierarchy.map((item, idx) => (
              <div key={idx} className="hierarchyItem">
                <span className="locationType">{item.type}:</span> {item.name}
              </div>
            ))
          ) : (
            <p>Nenhuma hierarquia encontrada.</p>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default InfoFieldLocations;
